
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Cursos from './pages/Cursos';
import Certificados from './pages/Certificados';
import Contatos from './pages/Contatos';
import Sobre from './pages/Sobre';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import FireSafetyProducts from "./components/FiresafetyProducts";
import ScrolltoTop from './components/ScrolltoTop';
import Servicos from './pages/Servicos';
function App() {
  return (
    <Router>
      <a href="#main" className="skip-link">Saltar para conteúdo</a>
      <Navbar/>
      <main id="main" className="main-content">
        <ScrolltoTop/>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/cursos" element={<Cursos/>}/>
          <Route path="/certificados" element={<Certificados/>}/>
          <Route path="/sobre" element={<Sobre/>}/>
          <Route path="/produtos" element={<FireSafetyProducts/>}/>
          <Route path="/servicos" element={<Servicos/>}/>
          <Route path="/contatos" element={<Contatos/>}/>
          <Route path="/Contatos" element={<Contatos/>}/>
        </Routes>
      </main>
      <Footer/>
    </Router>
  );
}

export default App;
